export const getUserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.error("Error getting timezone:", error);
    return "Asia/Makassar"; // Default fallback
  }
};

export const formatTimeInUserTimezone = (dateString, timezone = null) => {
  const userTimezone = timezone || getUserTimezone();
  const date = new Date(dateString);

  return new Intl.DateTimeFormat("id-ID", {
    timeZone: userTimezone,
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(date);
};

export const formatDateInUserTimezone = (dateString, timezone = null) => {
  const userTimezone = timezone || getUserTimezone();
  const date = new Date(dateString);

  return new Intl.DateTimeFormat("id-ID", {
    timeZone: userTimezone,
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
};

export const convertLocalTimeToUTC = (
  timeString,
  date = new Date(),
  timezone = null
) => {
  const userTimezone = timezone || getUserTimezone();
  const [hours, minutes] = timeString.split(":").map(Number);

  // Create date in user's timezone
  const localDate = new Date(date);
  localDate.setHours(hours, minutes, 0, 0);

  // Convert to UTC
  const utcDate = new Date(
    localDate.toLocaleString("en-US", { timeZone: "UTC" })
  );
  return utcDate;
};
